// extracted by mini-css-extract-plugin
export default {"option":"checkbox_option__YN0lV"};